import { LessonTask, LessonStep } from '../../../types/asset/lesson.types.ts';
import { ScriptProcessingResult } from '../../../types/asset/script.types.ts';

import { BaseScriptsProcessor } from './base-scripts-processor.ts';

/**
 * This processor is used to process the unknown file part of a script: "\\(??.file)"
 */
export class ScriptsFileUnknownProcessor extends BaseScriptsProcessor {
  public process(part: string, task: LessonTask, step: LessonStep): ScriptProcessingResult {
    if (part.startsWith('\\(') && part.endsWith('.file)')) {
      this.handleError(new Error('Unknown file part: ' + part), task, step);
      return { parts: [], processed: true };
    }
    return { parts: [], processed: false };
  }
}
